function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createSelector } from 'reselect';
import pathOr from 'ramda/src/pathOr';
import { CustomerStoreSelector, IsPIIDataAccessEnabledSelector } from './customer.selectors';
import { SEARCH_DROPDOWN_CONSTANTS, TRANSACTION_RECEIPT_TAX_BREAKOUT_PROPERTY } from '../../components/search/search.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CurrentBusinessUnitSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { SubscriberAdditionalPropertiesSelector } from '../../components/createCustomer/additionalPropertiesSection/additional.properties.filtered.selector';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { findByKey } from 'invision-core/src/utilities/ramda.helper';
import { getBoolOrDefault } from 'invision-core/src/components/helpers/bool.helper';
import CustomerCareLocaleKeys from '../../locales/keys';
import Immutable from 'seamless-immutable';
import { CUSTOMER_WRAPUP_PROPERTY } from '../constants/customer.wrapup.constants';
import { EMPTY_ARRAY } from '../constants/common.constants';
import { APIFeatureTogglesSelector } from 'invision-core/src/components/configurable/configurable.selectors';
var EMPTY_OBJECT = Immutable({});
export var SearchSelector = createSelector([CustomerStoreSelector], function (customerStore) {
  return customerStore.search;
});
export var SearchTypeSelector = createSelector([SearchSelector], function (search) {
  return search ? search.searchType : null;
});
export var IsSearchPanelVisibleSelector = createSelector([SearchSelector], function (search) {
  return search.isPanelVisible;
});
export var SearchIsFetchingResultsSelector = createSelector([SearchSelector], function (search) {
  return search.isFetchingResults;
});
var BusinessUnitTemplateSelector = createSelector([MetadataCodeTypeDictionarySelector(CODES.BusinessUnitTemplate), CurrentBusinessUnitSelector], function (templateCodeType, currentBusinessUnit) {
  var currentBusinessUnitId = currentBusinessUnit && currentBusinessUnit.id;
  var codes = templateCodeType && Object.values(templateCodeType) || EMPTY_ARRAY;
  if (!codes || !codes.length) {
    return null;
  }
  var currentBusinessUnitTemplate = codes.find(function (code) {
    return code && code.AdditionalProperties && code.AdditionalProperties.BusinessUnitId === currentBusinessUnitId;
  }) || codes.find(function (code) {
    return code.Global;
  });
  var template = currentBusinessUnitTemplate && currentBusinessUnitTemplate.AdditionalProperties && currentBusinessUnitTemplate.AdditionalProperties.Template;
  return template ? JSON.parse(template) : null;
});
export var SearchOptionsSelector = createSelector([IsDbss, IsPIIDataAccessEnabledSelector, SearchTypeSelector, BusinessUnitTemplateSelector, SubscriberAdditionalPropertiesSelector], function (isDbss, isPIIDataAccessEnabled, searchType, template, additionalProperties) {
  var billingItems = pathOr([], ['subNavigation', 'billing'], template);
  var hasTransactions = billingItems.includes('transactions');
  var searchableAdditionalProperties = additionalProperties.find(function (property) {
    return property.isSearchable;
  });
  var options = [{
    id: SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL,
    text: i18n.translate(CustomerCareLocaleKeys.INDIVIDUAL),
    selected: false
  }].concat(_toConsumableArray(isDbss ? [{
    id: SEARCH_DROPDOWN_CONSTANTS.COMPANY,
    text: i18n.translate(CustomerCareLocaleKeys.COMPANY),
    selected: false
  }] : []), _toConsumableArray(isPIIDataAccessEnabled ? [{
    id: SEARCH_DROPDOWN_CONSTANTS.ADDRESS,
    text: i18n.translate(CustomerCareLocaleKeys.ADDRESS),
    selected: false
  }] : []), [{
    id: SEARCH_DROPDOWN_CONSTANTS.ORDERSORBILLING,
    text: i18n.translate(CustomerCareLocaleKeys.ORDERS_OR_BILLING),
    selected: false
  }], _toConsumableArray(hasTransactions && isPIIDataAccessEnabled ? [{
    id: SEARCH_DROPDOWN_CONSTANTS.TRANSACTION,
    text: i18n.translate(CustomerCareLocaleKeys.TRANSACTION),
    selected: false
  }] : []), _toConsumableArray(searchableAdditionalProperties ? [{
    id: isDbss ? SEARCH_DROPDOWN_CONSTANTS.ADDITIONAL_PROPERTIES : SEARCH_DROPDOWN_CONSTANTS.ADDITIONAL_PROPERTIES,
    text: i18n.translate(isDbss ? CustomerCareLocaleKeys.ADDITIONAL_PROPERTIES : CustomerCareLocaleKeys.ADDITIONAL_PROPERTIES),
    selected: false
  }] : []));
  return options.map(function (option) {
    return Object.assign({}, option, {
      selected: option.id === searchType
    });
  });
});
export var IsDbssCouponSupportEnabledSelector = createSelector([APIFeatureTogglesSelector], function (apiFeatureToggles) {
  return Boolean(apiFeatureToggles.EnableDBSSCouponSupport);
});
export var SearchTypeTabsSelector = createSelector([IsDbss, IsDbssCouponSupportEnabledSelector], function (isDbss, isDbssCouponSupportEnabled) {
  return getSearchTypeTabs(isDbss, isDbssCouponSupportEnabled);
});
var SearchErrorSelector = createSelector([SearchSelector], function (search) {
  return search.searchError;
});
var EMPTY_SEARCH_API_ERRORS = [];
export var SearchApiErrorSelector = createSelector([SearchErrorSelector], function (searchError) {
  return searchError ? [searchError.message] : EMPTY_SEARCH_API_ERRORS;
});
var getSearchTypeTabs = function getSearchTypeTabs(isDbss, isDbssCouponSupportEnabled) {
  var tabData = [{
    id: SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL,
    active: true,
    glyph: 'logo_customer_care'
  }];
  if (!isDbss) {
    tabData.push({
      id: SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD,
      active: false,
      glyph: 'redeem-gift-orders-lg'
    });
  }
  if (!isDbss || isDbssCouponSupportEnabled) {
    tabData.push({
      id: SEARCH_DROPDOWN_CONSTANTS.COUPON,
      active: false,
      glyph: 'discounts-lg'
    });
  }
  return tabData;
};
export var SubscriberSearchForCurrentBusinessUnitSelector = createSelector([MetadataCodeLoadedSelector(CODES.SubscriberSearchConfig), MetadataCodeTypeSelector(CODES.SubscriberSearchConfig)], function (isSubscriberSearchConfigLoaded, subscriberSearchConfigCodes) {
  var currentBusinessUnitCode = undefined;
  var globalCode = undefined;
  if (isSubscriberSearchConfigLoaded) {
    var _iterator = _createForOfIteratorHelper(subscriberSearchConfigCodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var code = _step.value;
        //Check if the given BU has a record and it's enabled
        if (code.Global) {
          globalCode = code;
        } else {
          currentBusinessUnitCode = code;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return currentBusinessUnitCode || globalCode || EMPTY_OBJECT;
});
export var IsCustomerWrapUpRequiredSelector = createSelector([SubscriberSearchForCurrentBusinessUnitSelector], function (subscriberSearchConfigCode) {
  var isCustomerWrapUpRequired = false;
  if (Object.keys(subscriberSearchConfigCode).length) {
    var customerWrapUpAttribute = findByKey(CUSTOMER_WRAPUP_PROPERTY, subscriberSearchConfigCode.AdditionalProperties);
    isCustomerWrapUpRequired = getBoolOrDefault(pathOr(null, ['Value'], customerWrapUpAttribute), false);
  }
  return isCustomerWrapUpRequired;
});
export var IsTransactionReceiptTaxBreakoutEnabledSelector = createSelector([SubscriberSearchForCurrentBusinessUnitSelector], function (subscriberSearchConfigCode) {
  var isTransactionReceiptTaxBreakoutEnabled = false;
  if (Object.keys(subscriberSearchConfigCode).length) {
    var transactionReceiptTaxBreakout = findByKey(TRANSACTION_RECEIPT_TAX_BREAKOUT_PROPERTY, subscriberSearchConfigCode.AdditionalProperties);
    isTransactionReceiptTaxBreakoutEnabled = getBoolOrDefault(pathOr(null, ['Value'], transactionReceiptTaxBreakout), false);
  }
  return isTransactionReceiptTaxBreakoutEnabled;
});
export var IsPredictiveSearchEnabledSelector = createSelector([MetadataCodeLoadedSelector(CODES.SubscriberSearchConfig), MetadataCodeTypeSelector(CODES.SubscriberSearchConfig)], function (isSubscriberSearchConfigLoaded, subscriberSearchConfig) {
  if (isSubscriberSearchConfigLoaded) {
    var globalCode, buCode;
    subscriberSearchConfig.forEach(function (code) {
      if (code.Global) {
        globalCode = code;
      } else {
        buCode = code;
      }
    });
    if (buCode) {
      return getBoolOrDefault(pathOr(false, ['AdditionalProperties', '0', 'Value'], buCode), false);
    } else {
      return getBoolOrDefault(pathOr(false, ['AdditionalProperties', '0', 'Value'], globalCode), false);
    }
  } else {
    return false;
  }
});